type Reducers = {
  [key: string]: (state: any, action: any) => any;
};

const createCombinedStateReducer = (reducers: Reducers) => {
  return (state: any = {}, action: any = {}) => {
    // This is the object we are going to return.
    const nextState: any = {};

    // Loop through all the reducers
    for (const [key, reducer] of Object.entries(reducers)) {
      // Get the the previous state
      const stateForKey = state[key];
      // Get the next state by running the reducer
      const nextStateForKey = reducer(stateForKey, action);
      // Update the new state for the current reducer
      nextState[key] = nextStateForKey;
    }

    return nextState;
  };
};

export default createCombinedStateReducer;
